module.exports = __webpack_public_path__ + "static/media/swan.af29cfba.jpg";